export const validateEmail = (mail) => {
  const re = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
  if (re.test(mail)) {
    return false;
  }
  return `Please enter a valid email`;
};

const validatePhone = (phone) => {
  if (phone.length >= 8) return false;
  return `Phone number must be at least 8 digits.`;
};

export const validateText = (text) => {
  if (text.length) return false;
  return `Please complete the required field.`;
};

export const validateInput = (input) => {
  const returnInput = input;
  switch (input.type) {
    case `email`:
      returnInput.error = validateEmail(input.value);
      break;
    case `tel`:
    case `phone`:
      returnInput.error = validatePhone(input.value);
      break;
    case `text`:
      returnInput.error = validateText(input.value);
      break;
    default:
      returnInput.error = validateText(input.value);
      break;
  }
  return returnInput;
};

export const validateInputArray = (inputArray) =>
  inputArray.map((input) => validateInput(input));
